/** Stable, collision-resistant enough ids without any dependency. */

/** FNV-1a 32 bit hash, rendered as base36. */
function hash32(input: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(36);
}

/**
 * Derives a card id from the word pair and its learning goal. Re-importing the
 * same list keeps the existing progress, because the ids stay identical.
 *
 * Without a group the key is exactly the word pair, so ids written before
 * learning goals existed stay valid.
 */
export function makeCardId(native: string, foreign: string, group = ''): string {
  const pair = `${native.trim().toLowerCase()}\u0000${foreign.trim().toLowerCase()}`;
  const normalizedGroup = group.trim().toLowerCase();
  const key = normalizedGroup === '' ? pair : `${normalizedGroup}\u0000${pair}`;
  return `c_${hash32(key)}_${key.length.toString(36)}`;
}

export function makeSetId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `s_${crypto.randomUUID()}`;
  }
  return `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}
